import { openDB } from 'idb';

const DB_NAME = 'ghostUserDB';
const STORE_NAME = 'userList';
const DB_VERSION = 1;
const CACHE_DURATION = 24 * 60 * 60 * 1000;

const initDB = async () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        const store = db.createObjectStore(STORE_NAME, { keyPath: 'userId' });
        store.createIndex('email', 'email', { unique: false });
        store.createIndex('name', 'name', { unique: false });
        store.createIndex('lastUpdated', 'lastUpdated', { unique: false });
      }
    },
  });
};

export const saveUserListToIndexedDB = async (userList) => {
  try {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    
    await store.clear();
    
    const timestamp = Date.now();
    for (const user of userList) {
      await store.put({
        userId: user.id,
        name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
        email: user.email,
        avatar: user.avatar || '',
        role: user.roleId || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        lastUpdated: timestamp,
      });
    }
    
    await tx.done;
    localStorage.setItem('userListLastUpdated', timestamp.toString());
    return true;
  } catch (error) {
    console.error('Error saving user list to IndexedDB:', error);
    return false;
  }
};

export const getUserListFromIndexedDB = async () => {
  try {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const users = await store.getAll();
    await tx.done;
    return users;
  } catch (error) {
    console.error('Error getting user list from IndexedDB:', error);
    return [];
  }
};

export const isCacheValid = () => {
  const lastUpdated = localStorage.getItem('userListLastUpdated');
  if (!lastUpdated) return false;
  
  const timestamp = parseInt(lastUpdated, 10);
  const now = Date.now();
  return (now - timestamp) < CACHE_DURATION;
};

export const clearUserListCache = async () => {
  try {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await store.clear();
    await tx.done;
    localStorage.removeItem('userListLastUpdated');
    return true;
  } catch (error) {
    console.error('Error clearing user list cache:', error);
    return false;
  }
};

export const searchUsersInIndexedDB = async (query) => {
  try {
    const users = await getUserListFromIndexedDB();
    if (!query) return users;
    
    const lowerQuery = query.toLowerCase();
    return users.filter(user => 
      user.name.toLowerCase().includes(lowerQuery) ||
      user.email.toLowerCase().includes(lowerQuery)
    );
  } catch (error) {
    console.error('Error searching users in IndexedDB:', error);
    return [];
  }
};
